import Phaser from "phaser";

import { ASSETS, AVATAR_FRAME, SKIN_COUNT } from "../config";
import { registerAvatarAnimations } from "../entities/Avatar";

/** Carrega todos os assets e registra as animacoes antes de abrir a cidade. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super("boot");
  }

  preload(): void {
    const status = this.add
      .text(this.scale.width / 2, this.scale.height / 2, "Carregando a cidade…", {
        fontFamily: '"Nunito", "Segoe UI", system-ui, sans-serif',
        fontSize: "14px",
        color: "#8b90a6",
      })
      .setOrigin(0.5);

    this.load.on("progress", (value: number) => {
      status.setText(`Carregando a cidade… ${Math.round(value * 100)}%`);
    });
    this.load.on("loaderror", (file: Phaser.Loader.File) => {
      console.error("falha ao carregar asset", file.key, file.src);
      status.setColor("#e8706a").setText(`falha ao carregar ${file.key}`);
    });

    // mapa
    this.load.image("tileset-city", ASSETS.tileset);
    this.load.tilemapTiledJSON("city", ASSETS.map);
    this.load.atlas("props", ASSETS.props.image, ASSETS.props.atlas);

    // avatares
    for (let skin = 0; skin < SKIN_COUNT; skin++) {
      this.load.spritesheet(`avatar_${skin}`, ASSETS.avatar(skin), {
        frameWidth: AVATAR_FRAME.width,
        frameHeight: AVATAR_FRAME.height,
      });
    }
    this.load.spritesheet("ghost", ASSETS.ghost, {
      frameWidth: AVATAR_FRAME.width,
      frameHeight: AVATAR_FRAME.height,
    });

    // minigame: flappy
    this.load.spritesheet("flappy-bird", ASSETS.flappy.bird, { frameWidth: 16, frameHeight: 16 });
    this.load.image("flappy-pipe-body", ASSETS.flappy.pipeBody);
    this.load.image("flappy-pipe-cap", ASSETS.flappy.pipeCap);
    this.load.image("flappy-skyline", ASSETS.flappy.skyline);
    this.load.image("flappy-ground", ASSETS.flappy.ground);

    // minigame: corredor
    this.load.spritesheet("runner-tatu", ASSETS.runner.tatu, { frameWidth: 24, frameHeight: 24 });
    this.load.spritesheet("runner-vulture", ASSETS.runner.vulture, { frameWidth: 20, frameHeight: 14 });
    this.load.image("runner-cactus-small", ASSETS.runner.cactusSmall);
    this.load.image("runner-cactus-large", ASSETS.runner.cactusLarge);
    this.load.image("runner-ground", ASSETS.runner.ground);
    this.load.image("runner-cloud", ASSETS.runner.cloud);
  }

  create(): void {
    for (let skin = 0; skin < SKIN_COUNT; skin++) {
      registerAvatarAnimations(this, `avatar_${skin}`);
    }
    registerAvatarAnimations(this, "ghost");

    this.anims.create({
      key: "flappy-flap",
      frames: this.anims.generateFrameNumbers("flappy-bird", { start: 0, end: 2 }),
      frameRate: 10,
      repeat: -1,
    });

    // O tatu troca de frame na mao (a cadencia acompanha a velocidade), entao
    // so o urubu precisa de animacao pronta.
    this.anims.create({
      key: "runner-vulture-flap",
      frames: this.anims.generateFrameNumbers("runner-vulture", { start: 0, end: 1 }),
      frameRate: 7,
      repeat: -1,
    });

    this.scene.start("city");
  }
}
